import { Pipe, PipeTransform, inject } from '@angular/core';
import { OrderPositionStatus } from '../common/OrderPositionStatus';
import { OrderService } from '../services/order.service';

@Pipe({
    name: 'orderPositionStatusDisplayName',
})
export class OrderPositionStatusDisplayNamePipe implements PipeTransform {
  private orderService = inject(OrderService);

  constructor(){
    this.orderPositionStates = this.orderService.getOrderPositionStates();
  }

  private orderPositionStates: OrderPositionStatus[];
  
  /**
   * The display name of a position status, or null for none — no status yet, or one this build
   * does not know (#199: both threw). Never the raw code, which is not a word in any language.
   */
  transform(value: string | null | undefined): string | null {
    return this.orderPositionStates.find((s) => s.Id == value)?.DisplayName ?? null;
  }
}
